module.exports = __webpack_public_path__ + "static/media/RSILogo.2306fba7.png";